import './App.css';
import { Toaster } from 'sonner';
import { CustomCursor } from './components/CustomCursor';
import { SmoothScrollProvider } from './components/SmoothScrollProvider';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { TrustSection } from './components/TrustSection';
import { Testimonials } from './components/Testimonials';
import { ContactForm } from './components/ContactForm';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';

function App() {
  return (
    <SmoothScrollProvider>
      <div className="App">
        <CustomCursor />
        <Navigation />
        <Hero />
        <Services />
        <Portfolio />
        <TrustSection />
        <Testimonials />
        <ContactForm />
        <WhatsAppButton />
        <Footer />
        <Toaster position="top-right" richColors />
      </div>
    </SmoothScrollProvider>
  );
}

export default App;
